<script lang="ts">
  import {createEventDispatcher, getContext, onMount} from 'svelte';
  // @ts-ignore
  import {Button} from '@px/button';
  import {Modal} from '@/widgets';
  import lang from './RestrictedIP.lang';
  import {sd} from '@/da';

  const LG = getContext('LG');
  const dispatch = createEventDispatcher();

  export let country = '';
  export let countryCode = '';

  onMount(() => {
    sd.track('page_view', {$screen_name: 'Register Notice', $element_content: 'Register Notice'});
  });

  function handleConfirmClick() {
    sd.track('web_click', {$screen_name: 'Register Notice', $element_content: 'Not_US'});
    dispatch('confirm');
  }

  function handleClose() {
    sd.track('web_click', {$screen_name: 'Register Notice', $element_content: 'Cancel'});
    dispatch('close');
  }
</script>

<style>
  :global(.ip-restricted-popup .modal-body) {
    padding: 20px 16px;
  }
</style>

<Modal on:close={handleClose} visible class="ip-restricted-popup" style="max-width: 90%;width: 480px;">
  <div class="wrap df fdc" style="gap: 20px">
    <div class="lh24 f18 fw3 T1">{LG(lang.RestrictedIP)}</div>
    <div class="df fdc">
      <div class="lh18 f14">{LG(countryCode === 'US' ? lang.NoticeDesc : lang.NoticeDesc1, {country})}</div>
      {#if countryCode === 'US'}
      <div class="lh18 f14">{LG(lang.NoticeDesc2)}</div>
      {/if}
    </div>
    <div class="df fdr aic jcfe" style="gap: 12px">
      <div class="df aic jcc cp f16 lh22" style="height: 44px;padding: 0 12px" on:click={handleClose}>{LG(lang.Cancel)}</div>
      <Button class="btn fw2 f16 lh22" newRadius type="primary" style="height: 44px;" on:click={handleConfirmClick}>
        {LG(countryCode === 'US' ? lang.ConfirmBtn : lang.ConfirmBtn1, {country})}
      </Button>
    </div>
  </div>
</Modal>
